import * as React from 'react';
import { TestProjectInputEditorStore } from '../../stores';
import { observer } from 'mobx-react-lite';
import { Select } from 'antd';

type Props = {
    store: TestProjectInputEditorStore;
};

const TestProjectTopicsAppSelector: React.FC<Props> = ({ store }) => {
    const inputSelectionStore = store.draft?.inputSelectionStore;

    if (!inputSelectionStore) {
        return null;
    }

    if (inputSelectionStore.topicInputsType !== 'Bindings') {
        return null;
    }

    return (
        <Select
            disabled={!store.canEdit}
            className="test-project-mapping-application"
            options={inputSelectionStore.bindingApplications.map(app => ({
                title: app.name,
                label: app.name,
                value: app.id
            }))}
            showSearch
            value={inputSelectionStore.selectedAppForBindings || undefined}
            onChange={value => store.changeMappingApplication(value)}
            filterOption={(input, option) => option?.title && option.title.toLowerCase().includes(input.toLowerCase())}
            placeholder="Select target application"
        />
    );
};

export default observer(TestProjectTopicsAppSelector);
